import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Popover, message } from "antd";
import { find } from 'lodash';

import * as constants from '../../constants';
import SecurityMeasureForm from './SecurityMeasureForm';

import core from '../../../core';
import uistate from '../../../uistate';
import globalappstate from '../../../globalappstate';
import common from '../../../../common';

const { GenericTable } = core;


class SecurityMeasuresGrid extends Component {

    state = {
        addFormVisible: false,
        editFormVisible: false,
        currentEditEntity: {},
    };

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'SecurityMeasuresGrid', key);
    }

    //#region Grid button handlers

    onAddClicked = (e) => {
        this.setState({
            currentEditEntity: { idProcessedData: this.props.idProcessedData, Id: -1 },
            addFormVisible: true,
        });
    }
    onDeleteClicked = (idx) => {
        this.props.arrayHelper.remove(idx);
    }
    //#endregion    

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addFormVisible: false,
            editFormVisible: false,
            currentEditEntity: {},
        });
    }
    handleEntityAdd = (values) => {
        values.forEach(i => {
            this.props.arrayHelper.push(i);
        });
        this.setState({
            addFormVisible: false,
            currentEditEntity: {},
        });
    }
    //#endregion

    render() {
        const readOnly = this.props.readOnly ? this.props.readOnly : false;
        const columns = [{
            title: this.label('Name'),
            dataIndex: 'nameSecurityMeasure',
            key: 'nameSecurityMeasure',
            render: (text, record) => (
                <span>{record.name ? record.name : record.nameSecurityMeasure } </span>
            )
        }];

        return (
            <div className='securitymeasure'>
                <GenericTable aligntop multiline columns={columns} data={this.props.items} keyfield='idx' itemName={this.label('SecurityMeasureItem')} pagesize={5}
                    onAdd={this.onAddClicked}
                    readOnly={readOnly}
                    onDelete={this.onDeleteClicked} />

                <Modal title={this.label("AddModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.addFormVisible} 
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <SecurityMeasureForm picklists={this.props.picklists} labels={this.props.labels} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityAdd} />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {

    })
    (SecurityMeasuresGrid);  